// extracted by mini-css-extract-plugin
export var body = "ARbWScqd0lUijsP6F8jz";
export var hero = "yjjLSCZjlxro5RQStihH";
export var large = "wmk16hJuWKEejmBiqVnA";
export var micro = "sNphrla6lko9ZVndOZUQ";
export var mini = "ffei8WpbX5a04hnLNLap";
export var small = "Oz5cu64oiCPzgXYz8TRz";
export var title1 = "NziVCe8LukS1TypwfDih";
export var title2 = "jYS3527mmAZNnNH_i_U7";
export var title3 = "hiBgT3RtttFrlUsP0v7R";